import * as types from "../types";

const showHideLoaderAction = (showHideLoader) =>  {
    return {
        type: types.SHOW_LOADER,
        payload: showHideLoader,
    }
}
export default showHideLoaderAction;